<template>
    <SideHeader :indexPage="true" />
  
  <div style="padding-top: 55px;">
    <!-- loader -->
    <div id="loader" v-if="loading">
      <div class="spinner-border text-primary" role="status"></div>
    </div>
    <!-- * loader -->
    <div v-else>
      
      <div class="section full mt-2 mb-2">
        <div class="section-title">تکمیل اطلاعات پروفایل</div>
        <div class="wide-block pb-1 pt-2">
          <div v-if="profile.authStatus == 2 || profile.authStatus == 4" class="alert alert-outline-success alert-dismissible fade show" role="alert">
              <h4 class="alert-title">راننده گرامی</h4>
              اطلاعات حساب کاربری شما تایید شد، در صورت نیاز به ویرایش اطلاعات با پشتیبانی تماس بگیرید
              <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
          </div>
          <div v-if="profile.authStatus == 0 && profile.operatorMessage != ''" class="alert alert-outline-danger alert-dismissible fade show" role="alert">
              <h4 class="alert-title">راننده گرامی</h4>
              اطلاعات حساب کاربری شما رد شد، {{ profile.operatorMessage }}
              <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
          </div>
          <form enctype="multipart/form-data">
            <div class="form-group boxed">
              <div class="input-wrapper">
                <label class="form-label" for="name">نام</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  v-model="profile.name"
                  autocomplete="off"
                  :disabled="profile.name !== ''"
                />
                <i class="clear-input">
                  <ion-icon
                    name="close-circle"
                    role="img"
                    class="md hydrated"
                    aria-label="close circle"
                  ></ion-icon>
                </i>
              </div>
            </div>

            <div class="form-group boxed">
              <div class="input-wrapper">
                <label class="form-label" for="lastName">نام خانوادگی</label>
                <input
                  type="text"
                  class="form-control"
                  id="lastName"
                  v-model="profile.lastName"
                  autocomplete="off"
                  :disabled="profile.lastName !== ''"
                />
                <i class="clear-input">
                  <ion-icon
                    name="close-circle"
                    role="img"
                    class="md hydrated"
                    aria-label="close circle"
                  ></ion-icon>
                </i>
              </div>
            </div>

            <div class="form-group boxed">
              <div class="input-wrapper">
                <label class="form-label" for="mobileNumber">شماره همراه</label>
                <input
                  type="text"
                  class="form-control"
                  id="mobileNumber"
                  v-model="profile.mobileNumber"
                  autocomplete="off"
                  :disabled="profile.mobileNumber !== ''"
                />
                <i class="clear-input">
                  <ion-icon
                    name="close-circle"
                    role="img"
                    class="md hydrated"
                    aria-label="close circle"
                  ></ion-icon>
                </i>
              </div>
            </div>

            <div class="form-group boxed">
              <div class="input-wrapper">
                <label class="form-label" for="nationalCode">کد ملی</label>
                <input
                  type="text"
                  class="form-control"
                  id="nationalCode"
                  v-model="profile.nationalCode"
                  autocomplete="off"
                  disabled
                />
                <i class="clear-input">
                  <ion-icon
                    name="close-circle"
                    role="img"
                    class="md hydrated"
                    aria-label="close circle"
                  ></ion-icon>
                </i>
              </div>
            </div>

            <div class="form-group boxed">
              <div class="input-wrapper">
                <label class="form-label" for="address">آدرس</label>
                <textarea
                  id="address"
                  rows="2"
                  v-model="profile.address"
                  class="form-control"
                  :disabled="
                  profile.address != null">
                </textarea>
                <i class="clear-input">
                  <ion-icon
                    name="close-circle"
                    role="img"
                    class="md hydrated"
                    aria-label="close circle"
                  ></ion-icon>
                </i>
              </div>
            </div>

            <div class="form-group boxed">
              <div class="input-wrapper">
                <label class="form-label">شماره پلاک</label>
                <div class="input-group input-group-lg">
                  <input
                    type="text"
                    style="border-radius: 0px 4px 4px 0px;"
                    maxlength="2"
                    v-model="profile.vehicleLicensePlatePartD"
                    class="form-control border border-dark text-center"
                  />
                  <input
                    type="text"
                    maxlength="3"
                    style="border-left: none !important;"
                    v-model="profile.vehicleLicensePlatePartC"
                    class="form-control border border-dark text-center"
                  />
                  <select style="border-right: none !important;border-left: none !important;"
                    v-model="profile.vehicleLicensePlatePartB"
                    class="form-control border border-dark text-center"
                    id="city5">
                    <option selected value="الف">الف</option>
                    <option value="ب">ب</option>
                    <option value="پ">پ</option>
                    <option value="ت">ت</option>
                    <option value="ث">ث</option>
                    <option value="ج">ج</option>
                    <option value="چ">چ</option>
                    <option value="ح">ح</option>
                    <option value="خ">خ</option>
                    <option value="د">د</option>
                    <option value="ذ">ذ</option>
                    <option value="ر">ر</option>
                    <option value="ز">ز</option>
                    <option value="ژ">ژ</option>
                    <option value="س">س</option>
                    <option value="ش">ش</option>
                    <option value="ص">ص</option>
                    <option value="ض">ض</option>
                    <option value="ط">ط</option>
                    <option value="ظ">ظ</option>
                    <option value="ع">ع</option>
                    <option value="ف">ف</option>
                    <option value="ق">ق</option>
                    <option value="ک">ک</option>
                    <option value="گ">گ</option>
                    <option value="ل">ل</option>
                    <option value="م">م</option>
                    <option value="ن">ن</option>
                    <option value="و">و</option>
                    <option value="ه">ه</option>
                    <option value="ی">ی</option>
                  </select>
                    <input
                    maxlength="2"
                    type="text"
                    style="border-radius: 4px 0px 0px 4px; border-right: none !important;"
                    v-model="profile.vehicleLicensePlatePartA"
                    class="form-control border border-dark text-center"/>
                  
                </div>
                <i class="clear-input">
                  <ion-icon
                    name="close-circle"
                    role="img"
                    class="md hydrated"
                    aria-label="close circle"
                  ></ion-icon>
                </i>
              </div>
            </div>

            <div class="form-group boxed">
              <div class="input-wrapper">
                <label class="form-label" for="nationalCardImage">
                  تصویر کارت ملی</label
                >
                <input
                  type="file"
                  @change="handleFileNationalCardImage()"
                  ref="nationalCardImage"
                  accept="image/*"
                  class="form-control"
                  id="nationalCardImage"
                  v-if="profile.authStatus == 0"
                />
                <div>
                  <img
                    class="img-fluid" v-if="item.nationalCardImage !== ''"
                    :src="`${baseUrl}${profile.nationalCardImage}`"
                  />
                  <img
                    class="img-fluid"
                    :src="item.nationalCardImage"
                  />
                </div>
              </div>
            </div>

            <div class="form-group boxed">
              <div class="input-wrapper">
                <label class="form-label" for="authImage">تصویر احراز هویت</label>
                <div
                  class="input-info"
                  v-if="profile.authImage == null || profile.authImage == ''">
                  راننده عزیز لطفا کارت شناسایی عکس دار را در کنار صورت خود
                  قرارداده و عکس آن را ارسال کنید.
                </div>
                <input
                  type="file"
                  @change="handleFileAuthImage()"
                  ref="authImage"
                  accept="image/*"
                  class="form-control"
                  id="authImage"
                  v-if="profile.authStatus == 0"
                />
                <div>
                  <img
                    class="img-fluid"
                    :src="`${baseUrl}${profile.authImage}`"
                  />
                  <img
                    class="img-fluid"
                    :src="item.authImage"
                  />
                </div>
              </div>
            </div>

            <div class="form-group boxed">
              <div class="input-wrapper">
                <label class="form-label" for="driverSmartCardImage">ارسال تصویر کارت هوشمند راننده : (اختیاری)</label
                >
                <input
                  type="file"
                  class="form-control"
                  @change="handleFileDriverSmartCardImage()"
                  accept="image/*"
                  ref="driverSmartCardImage"
                  id="driverSmartCardImage"
                  v-if="profile.authStatus == 0"
                />
                <div>
                  <img
                    class="img-fluid"
                    :src="`${baseUrl}${profile.driverSmartCardImage}`"
                  />
                  <img
                    class="img-fluid"
                    :src="item.driverSmartCardImage"
                  />
                </div>
              </div>
            </div>
            <div class="form-group boxed">
              <button v-if="loadSend == true"
                @click.prevent="editProfile"
                type="submit"
                class="btn background-blue text-light btn-block">
                ثبت
              </button>
              <button v-else class="btn background-blue text-light btn-block" type="button" disabled>
              <span class="spinner-border spinner-border-sm me-05" role="status" aria-hidden="true"></span>
              درحال بررسی ...
            </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Swal from "sweetalert2";
import SideHeader from "@/components/SideHeader.vue";

export default {
  name: "profileEdit",
  components: {
    SideHeader
  },
  data() {
    return {
      baseUrl: "https://xpanel.s-bar.ir/",
      item:{
          authImage: null,
          nationalCardImage : null,
          // driverSmartCardImage : null
      },
      profile: {
        name: null,
        lastName: null,
        mobileNumber: null,
        nationalCode: null,
        address: null,
        operatorMessage: null,
        vehicleLicensePlatePartD: null,
        vehicleLicensePlatePartC: null,
        vehicleLicensePlatePartB: null,
        vehicleLicensePlatePartA: null,
        fleet_id: null,
        nationalCardImage: "noImage",
        authImage: "noImage",
        driverSmartCardImage: "noImage",
        driverImage: "noImage",
        carSmartCardImage: "noImage",
        imageAddressDoc: "noImage",
        authStatus: 0
      },
      loading : true,
      loadSend : true,
      axiosConfig: {
        headers: {
          'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
          'Accept': 'application/json'
        }
      }
    };
  },
  methods: {
    getDataProfile() {
      axios
        .get(`https://xpanel.s-bar.ir/api/driver/profile`, this.axiosConfig)
        .then((response) => {
          this.profile.name = response.data.data.name;
          this.profile.operatorMessage = response.data.data.operatorMessage;
          this.profile.lastName = response.data.data.lastName;
          this.profile.mobileNumber = response.data.data.mobileNumber;
          this.profile.nationalCode = response.data.data.nationalCode;
          this.profile.address = response.data.data.address;
          this.profile.fleet_id = response.data.data.fleet_id;
          this.profile.vehicleLicensePlatePartD =
            response.data.data.vehicleLicensePlatePartD;
          this.profile.vehicleLicensePlatePartC =
            response.data.data.vehicleLicensePlatePartC;
          this.profile.vehicleLicensePlatePartB =
            response.data.data.vehicleLicensePlatePartB;
          this.profile.vehicleLicensePlatePartA =
            response.data.data.vehicleLicensePlatePartA;
          this.profile.nationalCardImage = response.data.data.nationalCardImage;
          this.profile.authImage = response.data.data.authImage;
          this.profile.driverSmartCardImage =
            response.data.data.driverSmartCardImage;

          this.profile.authStatus =
          response.data.data.authStatus;

          this.loading = false;
        });
    },
    editProfile() {
      let formData = new FormData();
      
      if (
        this.profile.nationalCardImage == undefined ||
        this.profile.nationalCardImage == null
      )
        formData.append("nationalCardImage", "noImage");
      else formData.append("nationalCardImage", this.profile.nationalCardImage);

      if (this.profile.authImage == undefined || this.profile.authImage == null)
        formData.append("authImage", "noImage");
      else formData.append("authImage", this.profile.authImage);

      if (this.profile.driverImage == undefined || this.profile.driverImage == null)
        formData.append("driverImage", "noImage");
      else formData.append("driverImage", this.profile.driverImage);

      if (
        this.profile.imageAddressDoc == undefined ||
        this.profile.imageAddressDoc == null
      )
        formData.append("imageAddressDoc", "noImage");
      else formData.append("imageAddressDoc", this.profile.imageAddressDoc);

      if (
        this.profile.driverSmartCardImage == undefined ||
        this.profile.driverSmartCardImage == null
      )
        formData.append("driverSmartCardImage", "noImage");
      else
        formData.append("driverSmartCardImage", this.profile.driverSmartCardImage);

      if (
        this.profile.carSmartCardImage == undefined ||
        this.profile.carSmartCardImage == null
      )
        formData.append("carSmartCardImage", "noImage");
      else formData.append("carSmartCardImage", this.profile.carSmartCardImage);

      formData.append("name", this.profile.name);
      formData.append("lastName", this.profile.lastName);
      formData.append("_method", 'PUT');
      formData.append("mobileNumber", this.profile.mobileNumber);
      formData.append("address", this.profile.address);
      formData.append("fleet_id", this.profile.fleet_id);
      formData.append("nationalCode", this.profile.nationalCode);

      formData.append(
        "vehicleLicensePlatePartD",
        this.profile.vehicleLicensePlatePartD
      );
      formData.append(
        "vehicleLicensePlatePartC",
        this.profile.vehicleLicensePlatePartC
      );
      formData.append(
        "vehicleLicensePlatePartB",
        this.profile.vehicleLicensePlatePartB
      );
      formData.append(
        "vehicleLicensePlatePartA",
        this.profile.vehicleLicensePlatePartA
      );
          this.loadSend = false

      axios.post(
          `https://xpanel.s-bar.ir/api/driver/updateDriverProfileInfo`,formData, this.axiosConfig)
        .then((response) => {
          this.loadSend = true
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 2000,
          });
          setTimeout(function () {
            location.reload();
          }, 2200);
        })
        .catch(function (error) {
          // handle error
          // console.log(error);
        });
    },
    handleFileAuthImage() {
      const fileAuthImage = this.$refs.authImage.files[0]
      // const fileDriverSmartCardImage = this.$refs.driverSmartCardImage.files[0]


      this.item.authImage = URL.createObjectURL(fileAuthImage)
      // this.item.driverSmartCardImage = URL.createObjectURL(fileDriverSmartCardImage)

  
      this.profile.authImage = fileAuthImage
      // this.profile.driverSmartCardImage = fileDriverSmartCardImage
    },
    handleFileNationalCardImage() {
      const fileNationalCardImage = this.$refs.nationalCardImage.files[0]
      this.item.nationalCardImage = URL.createObjectURL(fileNationalCardImage)
      this.profile.nationalCardImage = fileNationalCardImage
    },
    handleFileDriverSmartCardImage() {
      const fileDriverSmartCardImage = this.$refs.driverSmartCardImage.files[0]
      this.item.driverSmartCardImage = URL.createObjectURL(fileDriverSmartCardImage)
      this.profile.driverSmartCardImage = fileDriverSmartCardImage
    }
  },
  mounted(){
    this.getDataProfile();
  }
};
</script>
<style>
</style>